export default __webpack_public_path__ + "static/media/SwedenFlag.8058213a.png";